import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const Overview = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_OVERVIEW.FETCH_OVERVIEW_SUMMARY:
      return { ...state, overviewSummary: action.value };
    case actions.FETCH_OVERVIEW.FETCH_FINANCIAL_OVERVIEW:
      return { ...state, financialOverview: action.value };
    case actions.FETCH_OVERVIEW.FETCH_GC_OVERVIEW:
      return { ...state, gcOverview: action.value };
    case actions.FETCH_OVERVIEW.FETCH_ONLINE_RECHARGE_SUMMARY:
      return { ...state, onlineRecharge: action.value };
    default:
      return state;
  }
};
export default Overview;
